import { Component } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NavController, NavParams } from "ionic-angular";
import { AlertController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { Payment } from "../../models/interfaces/payment.model";
import { PaymentType } from "../../models/interfaces/paymenttype.model";
import { PaymentPage } from "../../pages/payment/payment";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-payment_update",
  templateUrl: "payment_update.html",
})
export class PaymentUpdatePage {
  private paymenttype$: Observable<PaymentType[]>;
  private payment: any;
  private id: string;
  private py_id: string;
  private mb_id: string;
  private co_id: string;
  private pm_id: string;
  private mb_hashname: string;
  private mb_photo: string;
  private mb_status: string;
  private py_date: string;
  private pm_type: string;
  private py_amount: number;
  private py_remark: string;
  private paymentForm: FormGroup;
  private pType;
  private styleName: string ="";

  constructor(private configService: ConfigService,public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, private db: DbserviceProvider,
              public alertCtrl: AlertController,
  ) {
    console.log("PaymentUpdatePage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    this.id = this.navParams.get("id");
    this.paymentForm = this.formBuilder.group({
      "mb_hashname": "",
      "mb_photo": "",
      "mb_py_id": "",
      "mb_status": "",
      "pm_type": "",
      "py_amount": "",
      "py_date": "",
      "py_remark": "",
    });
    this.pType = this.paymentForm.value;
  }

  private ionViewWillEnter() {
    console.log("PaymentViewPage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("PaymentViewPage onInitPage");
    this.mb_id = this.navParams.data.id.mb_id;
    this.py_id = this.navParams.data.id.py_id;
    this.co_id = this.navParams.data.id.co_id;
    this.pm_id = this.navParams.data.id.pm_id;
    this.mb_hashname = this.navParams.data.id.mb_hashname;
    this.mb_photo = this.navParams.data.id.mb_photo;
    this.mb_status = this.navParams.data.id.mb_status;
    this.py_date = this.navParams.data.id.py_date;
    this.pm_type = this.navParams.data.id.pm_type;
    this.py_remark = this.navParams.data.id.py_remark;
    this.py_amount = this.navParams.data.id.py_amount;

    this.paymentForm.controls.mb_hashname.setValue(this.mb_hashname);
    this.paymentForm.controls.mb_py_id.setValue(this.py_id);
    this.paymentForm.controls.mb_photo.setValue(this.mb_photo);
    this.paymentForm.controls.mb_status.setValue(this.mb_status);
    this.paymentForm.controls.py_date.setValue(this.py_date);
    this.paymentForm.controls.pm_type.setValue(this.pm_type);
    this.paymentForm.controls.py_remark.setValue(this.py_remark);
    this.paymentForm.controls.py_amount.setValue(this.py_amount);

  }

  private ngOnDestroy() {
    console.log("PaymentUpdatePage ngOnDestroy");
    this.paymenttype$ = null;
  }

  private goback() {
    console.log("PaymentUpdatePage goback");
    this.navCtrl.pop();
  }

  private updatePayment(id: string, value: any) {
    console.log("PaymentUpdatePage updatePayment");

    const formValues: any = {
      "co_id": this.co_id,
      "mb_hashname": value.mb_hashname,
      "mb_id": this.mb_id,
      "mb_photo": value.mb_photo,
      "mb_status": value.mb_status,
      "pm_id": this.pm_id,
      "pm_type": this.pType.pm_type,
      "py_amount": value.py_amount,
      "py_date": value.py_date,
      "py_id": this.py_id,
      "py_remark": value.py_remark,
    };
    this.db.dbCol({ "action": "update", "mapObject": "payment", ...formValues })
      .subscribe();

    this.navCtrl.pop();
  }

  private deletePayment(id: any) {
    console.log("PaymentUpdatePage deletePayment");
    this.showConfirm("Payment", "Do you want to delete the Payment?", id);
  }

  private showConfirm(title: string, message: string, id: string) {
    console.log("PaymentUpdatePage showConfirm");
    let confirm = this.alertCtrl.create({
      "buttons": [
        {
          "handler": () => {
            this.db.dbCol({
              "action": "dml", "mapObject": "dml",
              "query": "DELETE FROM payment WHERE py_id=" + this.py_id,
            })
              .subscribe((ret) => {
                this.navCtrl.pop();
              });
          },
          "text": "Yes",
        },
        {
          "handler": () => {},
          "text": "No",
        },
      ],
      "message": message,
      "title": title,
    });
    confirm.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/payment/payment_update.ts